import { styled } from "@givenwell/stitches";
import { colors } from "@givenwell/theme";
import { ComponentPropsWithRef, useContext } from "react";
import { FieldContext } from "./Field";

export type ErrorMessageProps = ComponentPropsWithRef<"p">;

export function ErrorMessage(props: ErrorMessageProps) {
  const { descriptionProps } = useContext(FieldContext);
  return <Root {...descriptionProps} {...props} />;
}

const Root = styled("p", {
  d: "block",
  fontScale: "sm",
  weight: 500,
  color: colors.red500,

  mr: 12,
});
